/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';

/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import { Row, Col } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import InputField from "components/Form/InputField";
import DialogComponent, { DialogConfirm, DialogRejected, ContentTextArea, TextArea2 } from 'components/Dialog';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

import { Title, Text } from "./styles";
import StepNavigation from "components/StepNavigation/index";

export default function ContactSelectionNotPreAgreed(props) {


  const [summary, setSummary] = useState({});
  const [policyPackMessage, setPolicyPackMessage] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [attachmentsTag, setAttachmentsTag] = useState([]);
  const [userComments, setUserComments] = useState(null);
  const operationContext = useContext(GlobalOperationContext);
  const authContext = useContext(GlobalAuthContext);
  const [selectedItems, setSelectedItems] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);

  /* const [rejectDocuments, setRejectDocuments] = useState(false); */

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const isClient = authContext.enumProfile == 1 ? true : false;

  const validation = () => {

    if (selectedItems.length >= 1) {
      return true;
    }
    else {
      return false;
    }
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);

      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
    loading.stop();
  };

  

  function handleSendApproval() {
    /* console.log(formik.current.values.policyPackMessage); */
    let valid = validation();

    if (valid != true) {
      mc.error('Please fill in all required fields.');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    //ToDo requestSentInsurerPolicyPack
    let body = {
      idOperation: props.match.params.idOperation,
      policyPackMessage: formik.current.values.policyPackMessage,
      insurers: []
    };

    insurers.forEach(x => {
      body.insurers.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedItems.forEach(x => {
      let i = body.insurers.findIndex(e => e.idPersonInsurer == x.idPersonInsurer);
      if (i != -1) {
        body.insurers[i].contacts.push({ idContact: x.idContact, email: x.email });
      }
    })

    fitinsur.requestSentInsurerPolicyPack(body)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/list`);
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);
    //TODO: mudar para a chamada que vai ser utlizada
    fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code != 200) {
        mc.error(res.ret_msg_details);
        /*  history.goBack(); */
        return;
      }
      if (res.ret_value.attachments) {
        setAttachments(res.ret_value.attachments)
      }
      //TODO: caso não necessite retirar
      if ('isEnabledBtnPolicyPack' in res.ret_value) {
        if (res.ret_value.isEnabledBtnPolicyPack == true) {

        }
      }
    })
  }

  function handleSelect(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
      console.log("list de contactos", selectedItems);
    };
  };

  function listContacts() {

    fitinsur.setAuthToken(authContext.token);

    loading.start();
    fitinsur.requestInsurerContacts(props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          loading.stop();
          return;
        }
        if (data.ret_value.length >= 1) {
          setInsurers(data.ret_value);
        }
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
    loading.stop();
  };

  const listItems = insurers.map((insurer) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {insurer.insurerFirstName}
        </Title>
      </Row>

      {
        insurer.contacts.map((contact) => (
          <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
            <Col style={{ flexDirection: "row", display: "flex" }}>
              <label>
                <CheckBox
                  onChange={() => { handleSelect(contact, insurer) }}
                  checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
                /* disabled={contact?.existContact ? true : false} */
                />
              </label>
              <Label /* textColor={ contact?.existContact ? Colors.GRAY[3] : null} */>
                {contact.nameContact}
              </Label>
            </Col>
            <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
              <Label /* textColor={ contact?.existContact ? Colors.GRAY[3] : null} */>{contact.email}</Label>
            </Col>
          </Row>
        ))
      }
    </>
  ));

  ////////////  Dialog ///////////////// 
  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleDialog(type) {
    if (type === "Approve") {
      setTypeDialog("Approve");
      setDialog({
        visible: true,
        title: "APPROVE NOT PRE AGREED PACK",
        icon: "TimesCircle",
        args: null,
      })
    } else {
      setTypeDialog("Reject");
      setDialog({
        visible: true,
        title: "REJECT NOT PRE AGREED PACK",
        icon: "TimesCircle",
        args: null,
      })
    }
  };

  function handleApproval() {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.wordingBrokerSrApprove(props.match.params.idOperation, userComments)
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          history.push('/list');

          /* history.push(`/broking/send-policy-pack-client/${props.match.params.idOperation}`,{idProduct:props.location.state.idProduct}); */
        } else {
          mc.error(resp.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostAproval - Error:', error);
        loading.stop();
      });

  };

  function handleReject() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingBrokerSrReject(props.match.params.idOperation, userComments)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Not Pre Agreed Rejected");
          history.push('/list');
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };
  //////////////////////////////////////////


  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    handleSummary();
    handleEnable();
    listContacts();

  }, [])

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <BrokingSummary data={summary} />

      <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
        {typeDialog === 'Approve' ?
          <ContentTextArea>
            <p>Deal Analysis information</p>
            <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
            <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
            <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
          </ContentTextArea>

          : typeDialog === 'Reject' ?
            <ContentTextArea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
            </ContentTextArea>
            : ''
        }
      </DialogComponent>

      <ContentCard title={isClient ? 'Client' : 'SEND ENDORSEMENT PACK - INSURERS'} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <Formik
          innerRef={formik}
          initialValues={{
            cc:'',
            notPreAgreedMessage: 'Loading'
          }}
          onSubmit={handleSendApproval}
        >

          {formikProps => (
            <Form>
              {isClient ? '' : <><Title>TO</Title>
                {listItems}
              </>
              }
              <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                <Title>
                  CC
                </Title>
              </Row>
              <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                <Col sm={6}>
                  <Field
                    name={'cc'}
                    value={formikProps.values.cc}
                    onChange={(e) => formikProps?.setFieldValue('cc', e)}
                    component={InputField}
                  />
                </Col>
              </Row>
              <Field
                label={'Endorsement Pack Message'}
                name={'notPreAgreedMessage'}
                value={formikProps.values.notPreAgreedMessage}
                onChange={(e) => formikProps?.setFieldValue('notPreAgreedMessage', e)}
                component={TextField}
              />

              {/*attachments.length >= 1 ?
                <Col>
                  <div style={{ marginTop: "20px" }}></div>
                  <Label style={{ fontSize: "16px important!" }}>Attachments</Label>
                  <TagsList2

                    tags={attachments}
                    disableType
                    hideTrash={props.location?.state?.hideFooter ? true : true}
                  />
                </Col>
                
              : ''*/}

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>

                <ButtonContent>

                  {isClient ?

                    <>
                      <Button
                        secundary
                        id="btnSubmitReject"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Reject") }}
                      >
                        REJECT
                      </Button>
                      <Button
                        style={{ marginLeft: "10px" }}
                        primary
                        id="btnSubmitApproved"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDialog("Approve") }}
                      >
                        APPROVE
                      </Button>

                    </> :

                    <>
                    <Button
                        style={{ marginLeft: "10px" }}
                        secundary
                        type="submit"
                        id="btncancel"
                      >
                        CANCEL
                      </Button>
                      <Button
                        style={{ marginLeft: "10px" }}
                        primary
                        type="submit"
                        id="btnSubmit"

                      >
                        SEND ENDORSEMENT PACK
                      </Button>
                    </>
                  }
                </ButtonContent>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}